/*
 * Authors: mariushirjanu
 * Created: 17/05/2024
 */
import { Injectable } from '@angular/core';
import { CompanyType } from '../company/company-data.service';
import { ICompany } from '../../../type_definitions/datatypes';
import { IUserData } from './auth/auth-data.service';
import { AuthService } from './auth/auth.service';

const PARTNER_LAM:string = 'PARTNER_LAM_USER';

// this class can only be used after the user is authenticated, as it relies on the AuthService
@Injectable()
export class GaUserService {
  private _currentUser:IUserData;
  private _company:ICompany;

  constructor(
    private authService:AuthService
  ) {
    this._currentUser = this.authService.getCurrentUser();
    this._company = this._currentUser?.location?.companyCountry?.company;
  }

  public get company():ICompany {
    return this._company;
  }

  public get isCustomerCompany():boolean {
    if (this._currentUser) {
      return this._company?.companyType === CompanyType.CUSTOMER;
    }
  }

  public get isVendorCompany():boolean {
    if (this._currentUser) {
      return this._company?.companyType === CompanyType.OEM;
    }
  }

  public get isPartnerCompany():boolean {
    if (this._currentUser) {
      return this._company?.companyType === CompanyType.BP;
    }
  }

  public get isPartnerLAMCompany():boolean {
    return this._company?.companyType === CompanyType.BP && this._currentUser?.userGroup?.code === PARTNER_LAM;
  }

  public get isPartnerNAMCompany():boolean {
    return this._company?.companyType === CompanyType.BP && this._currentUser?.userGroup?.code !== PARTNER_LAM;
  }
}